module.exports = __webpack_public_path__ + "static/media/company-logo.49696040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-logo.png
// module id = 105
// module chunks = 0